import React from "react";
import { connect } from "react-redux";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { appNavigate } from "../../app/actions.web";
import { openLoginModal } from "../../auth/actions";
import { authApi } from "../../auth/api";
import LoginModal from "../../auth/components/LoginModal.web";
import { isMobileBrowser } from "../../base/environment/utils";
import { translate, translateToHTML } from "../../base/i18n/functions";
import i18next from "../../base/i18n/i18next";
import Icon from "../../base/icons/components/Icon";
import { iconPollFigma, iconTextFigma, IconVideoFIgma, IconWarning, iconPollononFigma, iconMeetFigma, } from "../../base/icons/svg";
import getUnsafeRoomText from "../../base/util/getUnsafeRoomText.web";
import CalendarList from "../../calendar-sync/components/CalendarList.web";
import RecentList from "../../recent-list/components/RecentList.web";
import { AbstractWelcomePage, _mapStateToProps as baseMapStateToProps, } from "./AbstractWelcomePage";
import FloatingSupportButton from "./FloatingSupportButton";
import Footer from "./Footer.web";
import LandingNavbar from "./LandingNavbar";
import Tabs from "./Tabs";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
/**
 * The pattern used to validate room name.
 *
 * @type {string}
 */
export const ROOM_NAME_VALIDATE_PATTERN_STR = "^[^?&:\u0022\u0027%#]+$";
/**
 * Room ID validation regex pattern.
 * Accepts:
 * - Full URL: https://didarr.ir/9955fe71-8d8a-7a6d-2393-64a61f8b4eb17c04
 * - Room ID only: 9955fe71-8d8a-7a6d-2393-64a61f8b4eb17c04
 * Format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxxxxxx (40 chars)
 *
 * @type {RegExp}
 */
// export const ROOM_ID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{16}$/i;
// export const ROOM_URL_REGEX =
//     /^(https?:\/\/)?(www\.)?(didarr\.ir|didar\.[a-z]+)\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{16})$/i;
export const ROOM_NAME_REGEX = /^[a-z0-9]{3}-[a-z0-9]{3}$/i;
export const ROOM_URL_REGEX = /^(https?:\/\/)?(www\.)?(didarr\.ir|didar\.[a-z]+)\/([a-z0-9]{3}-[a-z0-9]{3})$/i;
/**
 * The Web container rendering the welcome page.
 *
 * @augments AbstractWelcomePage
 */
class WelcomePage extends AbstractWelcomePage {
    _additionalContentRef;
    _additionalToolbarContentRef;
    _additionalCardRef;
    _roomInputRef;
    _additionalCardTemplate;
    _additionalContentTemplate;
    _additionalToolbarContentTemplate;
    _titleHasNotAllowCharacter;
    _autoChangeInterval;
    featureRefs = [];
    /**
     * Default values for {@code WelcomePage} component's properties.
     *
     * @static
     */
    static defaultProps = {
        _room: "",
    };
    /**
     * Initializes a new WelcomePage instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            generateRoomNames: interfaceConfig.GENERATE_ROOMNAMES_ON_WELCOME_PAGE,
            activeFeatureIndex: 0,
            isLoginModalOpen: false,
            isJoiningRoom: false,
            joinError: "",
        };
        /**
         *
         * Used To display a warning massage if the title input has no allow character.
         *
         * @private
         * @type {boolean}
         */
        this._titleHasNotAllowCharacter = false;
        /**
         * The HTML Element used as the container for additional content. Used
         * for directly appending the additional content template to the dom.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalContentRef = null;
        this._roomInputRef = null;
        /**
         * The HTML Element used as the container for additional toolbar content. Used
         * for directly appending the additional content template to the dom.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalToolbarContentRef = null;
        this._additionalCardRef = null;
        /**
         * The template to use as the additional card displayed near the main one.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalCardTemplate = document.getElementById("welcome-page-additional-card-template");
        /**
         * The template to use as the main content for the welcome page. If
         * not found then only the welcome page head will display.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalContentTemplate = document.getElementById("welcome-page-additional-content-template");
        /**
         * The template to use as the additional content for the welcome page header toolbar.
         * If not found then only the settings icon will be displayed.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalToolbarContentTemplate = document.getElementById("settings-toolbar-additional-content-template");
        // Bind event handlers so they are only bound once per instance.
        this._onFormSubmit = this._onFormSubmit.bind(this);
        this._onRoomChange = this._onRoomChange.bind(this);
        this._onPasteClick = this._onPasteClick.bind(this);
        this._setAdditionalCardRef = this._setAdditionalCardRef.bind(this);
        this._setAdditionalContentRef = this._setAdditionalContentRef.bind(this);
        this._setRoomInputRef = this._setRoomInputRef.bind(this);
        this._setAdditionalToolbarContentRef = this._setAdditionalToolbarContentRef.bind(this);
        this._onLanguageChange = this._onLanguageChange.bind(this);
        this._onLoginClick = this._onLoginClick.bind(this);
        this._onCloseLoginModal = this._onCloseLoginModal.bind(this);
        this._onModalContentClick = this._onModalContentClick.bind(this);
        this._onFeatureClick = this._onFeatureClick.bind(this);
        this._onJoinClick = this._onJoinClick.bind(this);
        this._onNewMeetingClick = this._onNewMeetingClick.bind(this);
        this._onLoginSuccess = this._onLoginSuccess.bind(this);
    }
    /**
     * Implements React's {@link Component#componentDidMount()}. Invoked
     * immediately after this component is mounted.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentDidMount() {
        super.componentDidMount();
        document.body.classList.add("welcome-page");
        // Set initial RTL direction based on current language
        const currentLang = i18next.language || "fa";
        const rtlLanguages = ["fa", "ar", "he"];
        const isRtl = rtlLanguages.includes(currentLang);
        document.documentElement.dir = isRtl ? "rtl" : "ltr";
        document.documentElement.lang = currentLang;
        document.title = this.props.t("welcomepage.title");
        if (this.state.generateRoomNames) {
            this._updateRoomName();
        }
        if (this._shouldShowAdditionalContent()) {
            this._additionalContentRef?.appendChild(this._additionalContentTemplate?.content.cloneNode(true));
        }
        if (this._shouldShowAdditionalToolbarContent()) {
            this._additionalToolbarContentRef?.appendChild(this._additionalToolbarContentTemplate?.content.cloneNode(true));
        }
        if (this._shouldShowAdditionalCard()) {
            this._additionalCardRef?.appendChild(this._additionalCardTemplate?.content.cloneNode(true));
        }
        // Start auto-change interval for features
        this._autoChangeInterval = window.setInterval(() => {
            this.setState((prevState) => ({
                activeFeatureIndex: (prevState.activeFeatureIndex + 1) % 5,
            }));
        }, 3000);
        // Check if there's a pending room from direct URL access
        // If user tried to access a room URL without being authenticated,
        // open the login modal automatically
        const pendingRoom = localStorage.getItem("pendingRoom");
        if (pendingRoom) {
            // Clear it immediately so it doesn't trigger on next page load
            localStorage.removeItem("pendingRoom");
            if (!authApi.isAuthenticated()) {
                // Open login modal with the pending room
                this.props.dispatch(openLoginModal(pendingRoom));
            }
        }
    }
    /**
     * Implements React's {@link Component#componentWillUnmount()}. Invoked
     * immediately before this component is unmounted and destroyed.
     *
     * @inheritdoc
     * @returns {void}
     */
    /**
     * Removes the classname used for custom styling of the welcome page.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentWillUnmount() {
        super.componentWillUnmount();
        if (this._autoChangeInterval) {
            clearInterval(this._autoChangeInterval);
        }
        document.body.classList.remove("welcome-page");
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement|null}
     */
    render() {
        const { _moderatedRoomServiceUrl, t } = this.props;
        const { DEFAULT_WELCOME_PAGE_LOGO_URL, DISPLAY_WELCOME_FOOTER } = interfaceConfig;
        const showAdditionalContent = this._shouldShowAdditionalContent();
        const contentClassName = showAdditionalContent ? "with-content" : "without-content";
        const footerClassName = DISPLAY_WELCOME_FOOTER ? "with-footer" : "without-footer";
        return (React.createElement("div", { className: `welcome ${contentClassName} ${footerClassName}`, id: "welcome_page" },
            React.createElement(LandingNavbar, { logoUrl: DEFAULT_WELCOME_PAGE_LOGO_URL, onLoginClick: this._onLoginClick }),
            React.createElement(LoginModal, { onLoginSuccess: this._onLoginSuccess }),
            React.createElement("div", { className: "header" },
                React.createElement("div", { className: "header-container" },
                    React.createElement("h1", { className: "header-text-title" }, t("welcomepage.headerTitle")),
                    React.createElement("h2", { className: "header-text-subtitle" }, translateToHTML(t, "welcomepage.headerSubtitle")),
                    React.createElement("p", { className: "header-text-description" }, translateToHTML(t, "welcomepage.headerDescription")),
                    React.createElement("div", { id: "enter_room" },
                        React.createElement("div", { className: "join-meeting-container" },
                            React.createElement("div", { className: "join-meeting-container-box" },
                                React.createElement("div", { className: "enter-room-input-container" },
                                    React.createElement("form", { onSubmit: this._onFormSubmit },
                                        React.createElement("div", { className: "input-wrapper" },
                                            React.createElement("input", { "aria-disabled": "false", "aria-label": "Meeting name input", autoFocus: true, className: `enter-room-input engFont ${this.state.room ? 'enter-room-input--filled' : ''}`, id: "enter_room_field", onChange: this._onRoomChange, pattern: ROOM_NAME_VALIDATE_PATTERN_STR, placeholder: t("welcomepage.placeHolderInput"), ref: this._setRoomInputRef, style: { textTransform: "lowercase" }, type: "text", value: this.state.room }),
                                            React.createElement("button", { "aria-label": "Paste", className: "input-paste-btn", onClick: this._onPasteClick, type: "button" },
                                                React.createElement("svg", { fill: "none", height: "12", viewBox: "0 0 19 12", width: "19", xmlns: "http://www.w3.org/2000/svg" },
                                                    React.createElement("path", { clipRule: "evenodd", d: "M3.46788 7.16759e-07H14.8655C15.3047 -1.41844e-05 15.6837 -2.70984e-05 15.9959 0.025476C16.3253 0.0523935 16.653 0.111823 16.9683 0.272485C17.4387 0.512169 17.8212 0.894621 18.0609 1.36503C18.2215 1.68034 18.2809 2.00802 18.3079 2.33748C18.3334 2.64962 18.3334 3.02858 18.3333 3.46786V8.19881C18.3334 8.63809 18.3334 9.01705 18.3079 9.32919C18.2809 9.65865 18.2215 9.98633 18.0609 10.3016C17.8212 10.772 17.4387 11.1545 16.9683 11.3942C16.653 11.5548 16.3253 11.6143 15.9959 11.6412C15.6837 11.6667 15.3047 11.6667 14.8654 11.6667H3.4679C3.0286 11.6667 2.64963 11.6667 2.33748 11.6412C2.00802 11.6143 1.68034 11.5548 1.36503 11.3942C0.89462 11.1545 0.512169 10.772 0.272485 10.3016C0.111824 9.98633 0.0523936 9.65865 0.0254761 9.32919C-2.70984e-05 9.01705 -1.41844e-05 8.63808 7.16759e-07 8.19879V3.46788C-1.41844e-05 3.02859 -2.70984e-05 2.64962 0.025476 2.33748C0.0523936 2.00802 0.111824 1.68034 0.272485 1.36503C0.512169 0.89462 0.89462 0.512169 1.36503 0.272485C1.68034 0.111824 2.00802 0.0523935 2.33748 0.025476C2.64962 -2.70984e-05 3.02859 -1.41844e-05 3.46788 7.16759e-07ZM2.4732 1.68661C2.24681 1.7051 2.16288 1.7365 2.12168 1.7575C1.96487 1.83739 1.83739 1.96487 1.7575 2.12168C1.7365 2.16288 1.7051 2.24681 1.68661 2.4732C1.66732 2.70931 1.66667 3.01954 1.66667 3.5V8.16667C1.66667 8.64713 1.66732 8.95736 1.68661 9.19347C1.7051 9.41986 1.7365 9.50379 1.7575 9.54499C1.83739 9.7018 1.96487 9.82928 2.12168 9.90917C2.16288 9.93017 2.24681 9.96157 2.4732 9.98006C2.70931 9.99935 3.01954 10 3.5 10H14.8333C15.3138 10 15.624 9.99935 15.8601 9.98006C16.0865 9.96157 16.1705 9.93017 16.2117 9.90917C16.3685 9.82928 16.4959 9.7018 16.5758 9.54499C16.5968 9.50379 16.6282 9.41986 16.6467 9.19347C16.666 8.95736 16.6667 8.64713 16.6667 8.16667V3.5C16.6667 3.01954 16.666 2.70931 16.6467 2.4732C16.6282 2.24681 16.5968 2.16288 16.5758 2.12168C16.4959 1.96487 16.3685 1.83739 16.2117 1.7575C16.1705 1.7365 16.0865 1.7051 15.8601 1.68661C15.624 1.66732 15.3138 1.66667 14.8333 1.66667H3.5C3.01954 1.66667 2.70931 1.66732 2.4732 1.68661ZM3.33334 4.16667C3.33334 3.70643 3.70643 3.33333 4.16667 3.33333H4.175C4.63524 3.33333 5.00834 3.70643 5.00834 4.16667C5.00834 4.62691 4.63524 5 4.175 5H4.16667C3.70643 5 3.33334 4.62691 3.33334 4.16667ZM6.66667 4.16667C6.66667 3.70643 7.03976 3.33333 7.5 3.33333H7.50834C7.96857 3.33333 8.34167 3.70643 8.34167 4.16667C8.34167 4.62691 7.96857 5 7.50834 5H7.5C7.03976 5 6.66667 4.62691 6.66667 4.16667ZM10 4.16667C10 3.70643 10.3731 3.33333 10.8333 3.33333H10.8417C11.3019 3.33333 11.675 3.70643 11.675 4.16667C11.675 4.62691 11.3019 5 10.8417 5H10.8333C10.3731 5 10 4.62691 10 4.16667ZM13.3333 4.16667C13.3333 3.70643 13.7064 3.33333 14.1667 3.33333H14.175C14.6352 3.33333 15.0083 3.70643 15.0083 4.16667C15.0083 4.62691 14.6352 5 14.175 5H14.1667C13.7064 5 13.3333 4.62691 13.3333 4.16667ZM4.16667 7.91667C4.16667 7.45643 4.53976 7.08333 5 7.08333H13.3333C13.7936 7.08333 14.1667 7.45643 14.1667 7.91667C14.1667 8.37691 13.7936 8.75 13.3333 8.75H5C4.53976 8.75 4.16667 8.37691 4.16667 7.91667Z", fill: "black", fillRule: "evenodd" })))))),
                                React.createElement("button", { "aria-label": this.state.room
                                        ? t("welcomepage.startMeeting")
                                        : t("welcomepage.newMeeting"), className: `join-button ${this.state.room
                                        ? this._isValidRoomInput(this.state.room)
                                            ? ''
                                            : 'join-button--disabled'
                                        : ''}`, disabled: this.state.isJoiningRoom || (!!this.state.room && !this._isValidRoomInput(this.state.room)), onClick: this._isValidRoomInput(this.state.room)
                                        ? this._onJoinClick
                                        : this.state.room
                                            ? undefined
                                            : this._onNewMeetingClick, tabIndex: 0, type: "button" }, this.state.isJoiningRoom ? (React.createElement("span", { className: "join-spinner" })) : this.state.room ? (t("welcomepage.startMeeting")) : (t("welcomepage.newMeeting")))))),
                    _moderatedRoomServiceUrl && (React.createElement("div", { id: "moderated-meetings" }, translateToHTML(t, "welcomepage.moderatedMessage", { url: _moderatedRoomServiceUrl }))))),
            this._renderFeaturesSection(),
            DISPLAY_WELCOME_FOOTER && React.createElement(Footer, null),
            React.createElement(ToastContainer, null),
            React.createElement(FloatingSupportButton, null)));
    }
    /**
     * Renders the insecure room name warning.
     *
     * @inheritdoc
     */
    _doRenderInsecureRoomNameWarning() {
        return (React.createElement("div", { className: "insecure-room-name-warning" },
            React.createElement(Icon, { src: IconWarning }),
            React.createElement("span", null, getUnsafeRoomText(this.props.t, "welcome"))));
    }
    /**
     * Prevents submission of the form and delegates join logic.
     *
     * @param {Event} event - The HTML Event which details the form submission.
     * @private
     * @returns {void}
     */
    _onFormSubmit(event) {
        event.preventDefault();
        if (!this._roomInputRef || this._roomInputRef.reportValidity()) {
            this._onJoin();
        }
    }
    /**
     * Overrides the super to account for the differences in the argument types
     * provided by HTML and React Native text inputs.
     *
     * @inheritdoc
     * @override
     * @param {Event} event - The (HTML) Event which details the change such as
     * the EventTarget.
     * @protected
     */
    // @ts-ignore
    // eslint-disable-next-line require-jsdoc
    _onRoomChange(event) {
        const specialCharacters = ["?", "&", ":", "'", '"', "%", "#", "."];
        const value = event.target.value
            .replace(/[۰-۹]/g, (d) => String("۰۱۲۳۴۵۶۷۸۹".indexOf(d)))
            .replace(/[٠-٩]/g, (d) => String("٠١٢٣٤٥٦٧٨٩".indexOf(d)))
            .toLowerCase();
        this._titleHasNotAllowCharacter = specialCharacters.some((char) => value.includes(char));
        super._onRoomChange(value);
    }
    /**
     * Checks if the input is a valid room ID or URL.
     *
     * @param {string} input - The input to validate.
     * @private
     * @returns {boolean} True if valid.
     */
    _isValidRoomInput(input) {
        if (!input) {
            return false;
        }
        const trimmed = input.trim();
        // direct room code
        if (ROOM_NAME_REGEX.test(trimmed)) {
            return true;
        }
        // url with room code
        if (ROOM_URL_REGEX.test(trimmed)) {
            return true;
        }
        return false;
    }
    /**
     * Extracts room ID from a URL or returns the input if it's already a room ID.
     *
     * @param {string} input - The URL or room ID.
     * @private
     * @returns {string} The extracted room ID.
     */
    _extractRoomName(input) {
        if (!input) {
            return "";
        }
        const trimmed = input.trim();
        // اگر خود کد اتاق بود
        if (ROOM_NAME_REGEX.test(trimmed)) {
            return trimmed.toLowerCase();
        }
        // اگر لینک بود
        const match = trimmed.match(ROOM_URL_REGEX);
        if (match && match[4]) {
            return match[4].toLowerCase();
        }
        return "";
    }
    /**
     * Handles paste button click to paste clipboard content into room input.
     *
     * @private
     * @returns {void}
     */
    async _onPasteClick() {
        try {
            const text = await navigator.clipboard.readText();
            if (text && this._roomInputRef) {
                const converted = text
                    .replace(/[۰-۹]/g, (d) => String("۰۱۲۳۴۵۶۷۸۹".indexOf(d)))
                    .replace(/[٠-٩]/g, (d) => String("٠١٢٣٤٥٦٧٨٩".indexOf(d)))
                    .toLowerCase();
                this._roomInputRef.value = converted;
                super._onRoomChange(converted);
            }
        }
        catch (err) {
            console.error("Failed to read clipboard:", err);
        }
    }
    /**
     * Handles language change.
     *
     * @param {React.ChangeEvent<HTMLSelectElement>} event - The change event.
     * @private
     * @returns {void}
     */
    _onLanguageChange(event) {
        const lang = event.target.value;
        const rtlLanguages = ["fa", "ar", "he"];
        const isRtl = rtlLanguages.includes(lang);
        i18next.changeLanguage(lang);
        // Update document direction
        document.documentElement.dir = isRtl ? "rtl" : "ltr";
        document.documentElement.lang = lang;
        // Update page title
        document.title = this.props.t("welcomepage.title");
    }
    /**
     * Opens the login modal.
     *
     * @private
     * @returns {void}
     */
    _onLoginClick() {
        this.props.dispatch(openLoginModal());
    }
    /**
     * Closes the login modal.
     *
     * @private
     * @returns {void}
     */
    _onCloseLoginModal() {
        // Modal is now controlled via Redux
    }
    /**
     * Prevents click propagation on modal content.
     *
     * @param {React.MouseEvent} e - The click event.
     * @private
     * @returns {void}
     */
    _onModalContentClick(e) {
        e.stopPropagation();
    }
    /**
     * Handles feature item click.
     *
     * @param {React.MouseEvent<HTMLDivElement>} e - The click event.
     * @private
     * @returns {void}
     */
    _onFeatureClick(e) {
        const index = parseInt(e.currentTarget.dataset.index || "0", 10);
        this.setState({ activeFeatureIndex: index });
    }
    /**
     * Handles join button click - checks auth before joining.
     *
     * @private
     * @returns {void}
     */
    async _onJoinClick() {
        const input = this.state.room;
        if (!input) {
            return;
        }
        if (!this._isValidRoomInput(input)) {
            toast.error("فرمت نام اتاق نامعتبر است", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                rtl: true,
            });
            return;
        }
        const roomName = this._extractRoomName(input);
        if (!roomName) {
            return;
        }
        // Check authentication first
        if (!authApi.isAuthenticated()) {
            this.props.dispatch(openLoginModal(roomName));
            return;
        }
        this.setState({ isJoiningRoom: true, joinError: "" });
        try {
            const response = await authApi.checkRoomName(roomName);
            // If we get here, status is 200 and room exists
            this.props.dispatch(appNavigate(roomName));
        }
        catch (error) {
            console.error("Error checking room:", error);
            // Show error message based on status code
            let errorMessage = "خطا در اتصال به سرور. لطفاً دوباره تلاش کنید.";
            if (error.status === 404) {
                errorMessage = "این اتاق وجود ندارد. لطفاً نام اتاق را بررسی کنید.";
            }
            else if (error.status === 409) {
                errorMessage = "این اتاق قبلاً به پایان رسیده است.";
            }
            else if (error.data && error.data.message) {
                // Use API message if available for other errors
                errorMessage = error.data.message;
            }
            toast.error(errorMessage, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                rtl: true,
            });
        }
        finally {
            this.setState({ isJoiningRoom: false });
        }
    }
    /**
     * Handles new meeting button click - generates room and checks auth.
     *
     * @param {React.FormEvent} event - The form event.
     * @private
     * @returns {void}
     */
    async _onNewMeetingClick(event) {
        event.preventDefault();
        if (!authApi.isAuthenticated()) {
            this.props.dispatch(openLoginModal());
            return;
        }
        this.setState({ isJoiningRoom: true, joinError: "" });
        try {
            const response = await authApi.generateNameRoom();
            const roomName = response.roomName;
            // IMPORTANT: Clear flags BEFORE setting newMeetingAutoJoin
            // This ensures no interference from previous sessions
            localStorage.removeItem("wasInConference");
            localStorage.removeItem("shouldAutoRejoin");
            // Now set the flag for new meeting auto-join
            localStorage.setItem("newMeetingAutoJoin", "true");
            this.props.dispatch(appNavigate(roomName));
        }
        catch (error) {
            console.error("Failed to generate room", error);
            const errorMessage = "خطا در ایجاد جلسه. لطفاً دوباره تلاش کنید.";
            toast.error(errorMessage, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                rtl: true,
            });
            this.setState({ isJoiningRoom: false, joinError: errorMessage });
        }
    }
    /**
     * Handles successful login - navigates to pending room if exists.
     *
     * @private
     * @returns {void}
     */
    _onLoginSuccess() {
        // Check both Redux state and localStorage for pending room
        const { pendingRoom: reduxPendingRoom } = this.props;
        const localStoragePendingRoom = localStorage.getItem("pendingRoom");
        const pendingRoom = reduxPendingRoom || localStoragePendingRoom;
        if (pendingRoom) {
            // Clear the pending room from localStorage
            localStorage.removeItem("pendingRoom");
            // Navigate to the room
            this.props.dispatch(appNavigate(pendingRoom));
        }
    }
    /**
     * Renders tabs to show previous meetings and upcoming calendar events. The
     * tabs are purposefully hidden on mobile browsers.
     *
     * @returns {ReactElement|null}
     */
    _renderTabs() {
        if (isMobileBrowser()) {
            return null;
        }
        const { _calendarEnabled, _recentListEnabled, t } = this.props;
        const tabs = [];
        if (_calendarEnabled) {
            tabs.push({
                id: "calendar",
                label: t("welcomepage.upcomingMeetings"),
                content: React.createElement(CalendarList, null),
            });
        }
        if (_recentListEnabled) {
            tabs.push({
                id: "recent",
                label: t("welcomepage.recentMeetings"),
                content: React.createElement(RecentList, null),
            });
        }
        if (tabs.length === 0) {
            return null;
        }
        return React.createElement(Tabs, { accessibilityLabel: t("welcomepage.meetingsAccessibilityLabel"), tabs: tabs });
    }
    /**
     * Renders the features section with icons and device access.
     *
     * @returns {ReactElement}
     */
    _scrollToActiveFeature(index) {
        const el = this.featureRefs[index];
        if (!el)
            return;
        const parent = el.parentElement;
        if (!parent)
            return;
        // Only scroll if there's overflow (mobile)
        const canScroll = parent.scrollWidth > parent.clientWidth;
        if (!canScroll)
            return;
        // Get measurements
        const elRect = el.getBoundingClientRect();
        const parentRect = parent.getBoundingClientRect();
        // Calculate where element center is relative to parent's visible area
        const elCenterInParent = elRect.left + elRect.width / 2 - parentRect.left;
        const parentCenter = parentRect.width / 2;
        // Calculate scroll adjustment needed to center the element
        const scrollAdjustment = elCenterInParent - parentCenter;
        const newScrollLeft = parent.scrollLeft + scrollAdjustment;
        parent.scrollTo({
            left: Math.max(0, newScrollLeft),
            behavior: "smooth",
        });
    }
    componentDidUpdate(prevProps, prevState) {
        const index = this.state.activeFeatureIndex ?? 0;
        if (prevState.activeFeatureIndex !== index) {
            this._scrollToActiveFeature(index);
        }
    }
    _renderFeaturesSection() {
        const { t } = this.props;
        const activeIndex = this.state.activeFeatureIndex || 0;
        const features = [
            {
                icon: IconVideoFIgma,
                title: t("welcomepage.features.videoCall"),
                description: t("welcomepage.features.description"),
                description2: t("welcomepage.features.description2"),
                subdescription: t("welcomepage.features.videoCallSubdescription"),
                subdescription2: t("welcomepage.features.videoCallSubdescription2"),
                image: "./images/2calll.png",
            },
            {
                icon: iconPollononFigma,
                title: t("welcomepage.features.audioCall"),
                description: t("welcomepage.features.description"),
                description2: t("welcomepage.features.description2"),
                subdescription: t("welcomepage.features.audioCallSubdescription"),
                subdescription2: t("welcomepage.features.audioCallSubdescription2"),
                image: "./images/vote.png",
            },
            {
                icon: iconMeetFigma,
                title: t("welcomepage.features.meetings"),
                description: t("welcomepage.features.description"),
                description2: t("welcomepage.features.description2"),
                subdescription: t("welcomepage.features.meetingsSubdescription"),
                subdescription2: t("welcomepage.features.meetingsSubdescription2"),
                image: "./images/meeting.png",
            },
            {
                icon: iconPollFigma,
                title: t("welcomepage.features.screenShare"),
                description: t("welcomepage.features.description"),
                description2: t("welcomepage.features.description2"),
                subdescription: t("welcomepage.features.screenShareSubdescription"),
                subdescription2: t("welcomepage.features.screenShareSubdescription2"),
                image: "./images/sharescreen.png",
            },
            {
                icon: iconTextFigma,
                title: t("welcomepage.features.chat"),
                description: t("welcomepage.features.description"),
                description2: t("welcomepage.features.description2"),
                subdescription: t("welcomepage.features.chatSubdescription"),
                subdescription2: t("welcomepage.features.chatSubdescription2"),
                image: "./images/chat.png",
            },
        ];
        const activeFeature = features[activeIndex];
        return (React.createElement("div", { className: "features-section" },
            React.createElement("div", { className: "features-list" }, features.map((feature, index) => (React.createElement("div", { ref: (el) => (this.featureRefs[index] = el), className: `feature-item ${index === activeIndex ? "active" : ""}`, "data-index": index, key: index, onClick: this._onFeatureClick },
                React.createElement("span", null, feature.title),
                React.createElement("div", { className: "feature-icon" },
                    React.createElement(Icon, { src: feature.icon })))))),
            React.createElement("div", { className: "device-access-section" },
                React.createElement("div", { className: "device-image", key: `img-${activeIndex}` },
                    React.createElement("img", { alt: "\u062F\u06CC\u062F\u0627\u0631 \u062F\u0631 \u062F\u0633\u062A\u06AF\u0627\u0647\u200C\u0647\u0627\u06CC \u0645\u062E\u062A\u0644\u0641", src: activeFeature.image, loading: "lazy" })),
                React.createElement("div", { className: "device-content" },
                    React.createElement("h2", { className: "device-title" },
                        React.createElement(DotLottieReact, { autoplay: true, className: "logobox-small", loop: true, src: "images/didar-logo.json" }),
                        React.createElement("span", { className: "device-title-text", key: `title-${activeIndex}` },
                            activeFeature.description,
                            " ",
                            React.createElement("br", null),
                            activeFeature.description2)),
                    React.createElement("p", { className: "device-description", key: `desc-${activeIndex}` },
                        activeFeature.subdescription,
                        " ",
                        React.createElement("br", null),
                        activeFeature.subdescription2)))));
    }
    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * additional card shown near the tabs card.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the welcome page content.
     * @private
     * @returns {void}
     */
    _setAdditionalCardRef(el) {
        this._additionalCardRef = el;
    }
    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * welcome page content.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the welcome page content.
     * @private
     * @returns {void}
     */
    _setAdditionalContentRef(el) {
        this._additionalContentRef = el;
    }
    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * toolbar additional content.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the additional toolbar content.
     * @private
     * @returns {void}
     */
    _setAdditionalToolbarContentRef(el) {
        this._additionalToolbarContentRef = el;
    }
    /**
     * Sets the internal reference to the HTMLInputElement used to hold the
     * welcome page input room element.
     *
     * @param {HTMLInputElement} el - The HTMLElement for the input of the room name on the welcome page.
     * @private
     * @returns {void}
     */
    _setRoomInputRef(el) {
        this._roomInputRef = el;
    }
    /**
     * Returns whether or not an additional card should be displayed near the tabs.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalCard() {
        return (interfaceConfig.DISPLAY_WELCOME_PAGE_ADDITIONAL_CARD &&
            this._additionalCardTemplate?.content &&
            this._additionalCardTemplate?.innerHTML?.trim());
    }
    /**
     * Returns whether or not additional content should be displayed below
     * the welcome page's header for entering a room name.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalContent() {
        return (interfaceConfig.DISPLAY_WELCOME_PAGE_CONTENT &&
            this._additionalContentTemplate?.content &&
            this._additionalContentTemplate?.innerHTML?.trim());
    }
    /**
     * Returns whether or not additional content should be displayed inside
     * the header toolbar.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalToolbarContent() {
        return (interfaceConfig.DISPLAY_WELCOME_PAGE_TOOLBAR_ADDITIONAL_CONTENT &&
            this._additionalToolbarContentTemplate?.content &&
            this._additionalToolbarContentTemplate?.innerHTML.trim());
    }
}
function _mapStateToProps(state) {
    const authState = state["features/auth"];
    return {
        ...baseMapStateToProps(state),
        isAuthenticated: authState?.isAuthenticated ?? false,
        isLoginModalOpen: authState?.isLoginModalOpen ?? false,
        pendingRoom: authState?.pendingRoom ?? null,
    };
}
export default translate(connect(_mapStateToProps)(WelcomePage));
